export default {
    baseStyle: {
        editFormStack: {
            spacing: {base: 3}
        },
        editFormInnerStack: {
            spacing: 3
        },
        selectionStack: {
            spacing: 8
        },
        addressListStack: {
            spacing: 4
        },
        addressItemFlex: {
            justify: 'space-between',
            w: 'full'
        },
        addressItemBox: {
            padding: 4,
        },
        addressItemContent: {
            flex: '1'
        },
        addressEditIndicator: {
            width: 3,
            height: 3,
            borderLeft: '1px solid',
            borderTop: '1px solid',
            borderColor: 'blue.600',
            position: 'absolute',
            left: '50%',
            bottom: '-23px',
            background: 'white',
            transform: 'rotate(45deg)'
        },
        addNewAddressLink: {
            textStyle: 'labelXs',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
        },
        addNewAddressIcon: {
            w: '20px',
            h: '20px'
        }
    }
}
